import axios from "axios";
import { geoServerBaseUrl } from "./baseUrl";
import { get_area, get_poi } from "./site_selections";

const SERVER_URL = geoServerBaseUrl;

export const activities_timeseries = (body) => async (dispatch, getState) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(SERVER_URL + "/...", body, config);
    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  }
};

export const run_gap = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "run_site_selection",
    });

    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_poi",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_demo",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_grid_group",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_formula",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_save_feature",
        value: 0,
      },
    });

    const array_actions = [
      () => dispatch(get_area()),
      () => dispatch(get_poi()),
      () => dispatch(iso_my()),
    ];

    const delay_ms = 100;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = async () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };
    await parent_action();

    dispatch({
      type: "clear_loading_action",
      payload: "run_site_selection",
    });
  } catch (error) {
    throw error;
  }
};

export const iso_my = (body) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { features_poi } = state.insight_reducer;

    console.log("features_poi.length=", features_poi.length);
    console.log("iso_my - starting isochrone generation for all POIs");

    // Process all features in parallel
    const promises = features_poi.map((feature) =>
      dispatch(generate_isokron(feature))
    );

    await Promise.all(promises);

    console.log("iso_my - completed isochrone generation for all POIs");
  } catch (error) {
    console.error("Error in iso_my:", error);
  }
};

export const generate_isokron = (feature) => async (dispatch) => {
  try {
    const feature_new = { ...feature };

    const [long, lat] = feature_new.geometry.coordinates;
    let { isochrone_profile, contour_type, contours_minutes, contours_meters } =
      feature_new.properties;

    isochrone_profile = isochrone_profile || "driving";
    contour_type = contour_type || "minutes";
    contours_minutes = contours_minutes || 5;
    contours_meters = contours_meters || 500;

    let url;
    if (contour_type === "minutes") {
      url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_profile}/${long},${lat}?contours_minutes=${contours_minutes}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
    } else {
      url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_profile}/${long},${lat}?contours_meters=${contours_meters}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
    }
    const response = await axios.get(url);
    const geometry = response.data.features[0].geometry;
    feature_new.geometry = geometry;

    const get_most_west_coordinate = (feature_polygon) => {
      if (
        !feature_polygon ||
        !feature_polygon.geometry ||
        !feature_polygon.geometry.coordinates
      ) {
        throw new Error("Invalid polygon feature.");
      }
      const coordinates = feature_polygon.geometry.coordinates[0];
      let most_west_coordinate = coordinates.reduce((prev, curr) => {
        return curr[0] < prev[0] ? curr : prev;
      });
      return most_west_coordinate;
    };
    const most_west_coordinate = get_most_west_coordinate(feature_new);
    feature_new.properties.most_west_coordinate = most_west_coordinate;
    dispatch({
      type: "push_value_toolbox",
      payload: {
        key: "features_isokron",
        value: [feature_new],
      },
    });

    dispatch({
      type: "status_toolbox",
    });
  } catch (error) {
    console.error("Error fetching isokron:", error);
  }
};
